import { createSlice } from "@reduxjs/toolkit";
import axios from "axios";

const initialState = {
  mdaAgents: {
    data: [],
    currentPage: 0,
    numberOfPages: 0,
  },
  loading: false,
  error: null,
};

const slice = createSlice({
  name: "mdaAgent",
  initialState,
  reducers: {
    getMdaAgentSuccess: (state, { payload }) => {
      state.mdaAgents = payload;
      state.loading = false;
    },
    startLoadingMdaAgent: (state) => {
      state.loading = true;
    },
    hasError: (state, action) => {
      state.error = action.payload;
      state.loading = false;
    },
  },
});

export default slice.reducer;

export const getAllMdaAgents = ({ accessToken, page }) => {

  const headers = {
    "Content-Type": "application/json",
    Authorization: accessToken,
  };
  return async (dispatch) => {
    try {
     
      dispatch(slice.actions.startLoadingMdaAgent());
      const res = await axios.get(
        `${process.env.REACT_APP_BACKEND_API}/get-all-mdaAgents`,
        { headers }
      );
      dispatch(slice.actions.getMdaAgentSuccess(res.data));
    } catch (error) {
      dispatch(slice.actions.hasError(error.message));
    }
  };
};


